/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSchedulIntervalInfo } from "@/api";
import { mapGetters, mapMutations } from 'vuex';
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import { MUTATION_APPTREG_ADDREGINFO, GETTER_APPTREG_ADDREGINFO } from '@/store/mutation_types';
export default {
  props: {
    value: Boolean,
    flag: String
  },
  data: function data() {
    return {
      schduleDate: '',
      doctorDeptId: 'that.doctorDeptId',
      scheduleList: [],
      scheduleIndex: -1,
      intervalIndex: -1,
      scheduleSetName: ''
    };
  },
  directives: {
    TransferDom: TransferDom
  },
  components: {},
  created: function created() {
    var flag = this.$router.currentRoute.flag;

    if (flag) {
      this.flag = flag;
    }
  },
  computed: _objectSpread({}, mapGetters({
    addRegInfo: GETTER_APPTREG_ADDREGINFO
  })),
  mounted: function mounted() {},
  watch: {
    value: function value(val) {
      if (val) {
        this.getChooseInfo();
        var bodyObj = document.getElementsByTagName("body")[0];
        var name = bodyObj.className;
        bodyObj.className = name + " vux-modal-open";
      } else {
        document.body.removeAttribute("class", "vux-modal-open");
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    console.log('beforeDestroy');
    document.body.removeAttribute("class", "vux-modal-open");
  },
  methods: _objectSpread(_objectSpread({}, mapMutations({
    setAddRegInfo: MUTATION_APPTREG_ADDREGINFO
  })), {}, {
    getChooseInfo: function getChooseInfo() {
      var _this = this;

      console.log('getChooseInfo:');
      this.appId = Utils.getUrlByParam('appId');
      this.clinicId = Utils.getUrlByParam('clinicId');
      this.clinicName = Utils.getUrlByParam('clinicName'); // this.addRegInfo = Utils.getCache(Cons.ADDREG_INFO_KEY);

      if (this.addRegInfo) {
        this.schduleDate = this.addRegInfo.schduleDate;
        this.doctorDeptId = this.addRegInfo.doctorDeptId;
        this.childClinicId = this.addRegInfo.childClinicId;
      }

      this.schduleObj = this.addRegInfo.schduleData;
      console.log(this.childClinicId);
      GetSchedulIntervalInfo(this.schduleDate, this.doctorDeptId, this.childClinicId).then(function (data) {
        console.log('GetSchedulIntervalInfo');
        console.log(data);
        _this.scheduleList = data;
      });
    },
    hide: function hide() {
      this.scheduleIndex = -1;
      this.intervalIndex = -1;
      this.scheduleList = [];
      this.$emit('input', false);
    },
    chooseInfo: function chooseInfo(index, index1, scheduleSetName, surplusQty) {
      if (surplusQty <= 0) {
        return;
      }

      this.scheduleIndex = index;
      this.intervalIndex = index1;
      this.scheduleSetName = scheduleSetName; //跳转确定预约界面
      // Public.getOauth2Code("weixin/apptReg/apptSure.html");
      // window.location.href = '../apptReg/apptSure.html';
      // this.$router.push({ name: 'ApptRegApptSure' })
    },
    chooseSure: function chooseSure() {
      /*缓存选择的排班详细信息*/
      var index = this.scheduleIndex,
          index1 = this.intervalIndex;
      var addRegInfo = Utils.getCache(Cons.ADDREG_INFO_KEY);
      addRegInfo.scheduleId = this.scheduleList[index].scheduleId;
      var TimeSpan = this.scheduleList[index].listIntervals[index1];
      addRegInfo.timeSpan = TimeSpan;
      addRegInfo.intervalTime = "".concat(TimeSpan.startTime, "-").concat(TimeSpan.endTime);
      addRegInfo.scheduleSetName = this.scheduleSetName;
      this.setAddRegInfo(addRegInfo);

      if (TimeSpan.surplusQty <= 0) {
        Public.tips({
          text: '该时段已约满'
        });
        return;
      } //跳转确定预约界面


      this.hide();

      if (this.flag) {
        this.$router.push({
          name: 'ApptRegSureChain',
          query: {
            flag: this.flag
          }
        });
      } else {
        this.$router.push({
          name: 'ApptRegApptSure',
          query: {
            flag: this.flag
          }
        });
      }
    }
  })
};